var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('span',[_vm._v("Copyright © "+_vm._s(_vm.$t('selectPage.wyd_global_development_center')))])])}
var staticRenderFns = []

export { render, staticRenderFns }